import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AppService } from '../../../../services/app.service';

@Component({
  selector: 'kt-demande-instruction',
  templateUrl: './demande-instruction-dialog.component.html',
  styleUrls: ['./demande-instruction-dialog.component.scss']
})
export class DemandeInstructionDialogComponent implements OnInit {
  demandes: any[];
  demande_type: any;
  selectedDemande: any;
  constructor(
    public dialogRef: MatDialogRef<DemandeInstructionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService : AppService
  ) { }

  ngOnInit() {
      this.demandes = this.data.demandes;
      this.demande_type = this.data.demande;
      this.demandes.forEach((demande) => {
          if(demande.ID === this.demande_type)
            this.selectedDemande = demande;
      })
  }

}
